import {
  type DispatcherEvent,
  generateNativeMessageSender
} from '@carvana/merch-native';
import { isNonProd } from '~/constants/environment';
import { logError } from '~/utilities/loggers';
import { source } from './constants';

export default generateNativeMessageSender<DispatcherEvent>({
  logError,
  source,
  verboseLogs: isNonProd
});
